import { Box, Card, CardContent, Typography } from "@mui/material";
import Logger from "../../services/Logger";

/** Copy of pages jigsaw TemplateCard for admin canvas tests. */
export default function TestTemplateCard({ template, selectedTemplate, setSelectedTemplate, difficultyColor }) {
    const isSelected = selectedTemplate?.id === template.id;

    return (
        <Card
            sx={{
                cursor: "pointer",
                transition: "all 0.2s",
                border: isSelected ? 2 : 1,
                borderColor: isSelected ? `${difficultyColor}.main` : "divider",
                "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: 3,
                },
            }}
            onClick={() => {
                setSelectedTemplate(template);
                Logger.info("Selected template:", template);
            }}
        >
            <CardContent sx={{ p: 2 }}>
                <Typography variant="subtitle2" gutterBottom>
                    {template.templateName}
                </Typography>

                <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
                    {template.tileSize}×{template.tileSize}
                </Typography>

                {template.svgPath && (
                    <Box
                        sx={{
                            textAlign: "center",
                            bgcolor: "grey.800",
                            p: 1,
                            borderRadius: 1,
                            position: "relative",
                            height: "120px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {template.piecePaths?.pieces ? (
                            <Box
                                component="svg"
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    maxWidth: "160px",
                                    maxHeight: "160px",
                                }}
                                viewBox={`0 0 ${template.tileSize * 64} ${template.tileSize * 64}`}
                            >
                                {template.piecePaths.pieces.map((piece, index) => (
                                    <path
                                        key={index}
                                        d={piece.path}
                                        fill="none"
                                        stroke="rgba(200, 200, 200, 0.8)"
                                        strokeWidth="2"
                                    />
                                ))}
                            </Box>
                        ) : (
                            <img
                                src={template.svgPath}
                                alt={`Template ${template.templateName}`}
                                style={{
                                    width: "100%",
                                    maxWidth: "160px",
                                    height: "auto",
                                    display: "block",
                                }}
                            />
                        )}
                    </Box>
                )}
            </CardContent>
        </Card>
    );
}
